let currentLocation = decodeURI(window.location),
  currentUrl = new URL(currentLocation),
  queryTerm = '',
  paramsArray = currentUrl.search.slice(1).split('&');

if (paramsArray.length > 0) {
  let newSearch = '';
  paramsArray.forEach(function (param) {
    let paramArray = param.split('='),
      paramName = paramArray[0],
      paramValue = paramArray[1];
    if (paramName !== 'page') {
      let paramString = paramName + '=' + paramValue + '&';
      newSearch += paramString;
    }
    if (paramName === 'q') {
      queryTerm = paramValue.replaceAll('+', ' ').replaceAll('%20', ' ');
    }
  });
  if (currentUrl.searchParams.get('page')) {
    newSearch = newSearch.slice(0, -1);
    newSearch = '?' + newSearch;

    let host = currentUrl.port ? currentUrl.hostname + ":" + currentUrl.port : currentUrl.hostname;

    window.location.href = currentUrl.protocol + '//' + host + currentUrl.pathname + newSearch;
  }
}

document.addEventListener("DOMContentLoaded", function () {
  let intervalAlgolia = setInterval(function () {
    const showMoreButton = document.querySelector('button.ais-InfiniteHits-loadMore'),
      widgetsLinks       = document.querySelectorAll('.ais-Menu-item[hidden="true"]'),
      emptyResult        = document.querySelector('.ais-InfiniteHits--empty');

    if (showMoreButton) {
      clearInterval(intervalAlgolia);
      initAlgolia();
    }

    if (emptyResult !== null) {
      clearInterval(intervalAlgolia);
      document.querySelector('.ais-facets').remove();
      document.querySelector('.ais-sort').remove();
      document.querySelector('.ais-search-header').remove();
      document.querySelector('.ais-page.page-width').classList.add('is-empty')
      document.querySelector('.section.collection-no-margin').classList.add('is-empty')
      if (document.querySelector('.ais-InfiniteHits--empty').closest('.ais-page.page-width').querySelector('.ais-facets-button')) {
        document.querySelector('.ais-InfiniteHits--empty').closest('.ais-page.page-width').querySelector('.ais-facets-button').remove();
      }

      const continueButton = document.querySelector('.ais-hit-empty .button.button--primary-small'),
        featuredProducts = document.getElementById('featured-products');

      if (featuredProducts !== null) {
        featuredProducts.removeAttribute('style');
      }

      if (continueButton !== null) {
        continueButton.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          window.location.href = '/collections/all';
        });
      }
    }
  }, 400);

  function initAlgolia() {
    
    const showMoreButton = document.querySelector('button.ais-InfiniteHits-loadMore'),
      ob = new IntersectionObserver(obCallback);
    let firstTry = true;
    window.tryQty = 0;
      
    function obCallback(payload) {
      if (document.querySelector('[class="ais-facet-meta.key_features.grown_zones-container"]')) {
        document.querySelector('[class="ais-facet-meta.key_features.grown_zones-container"]').style.minHeight = 'auto';
      }
      if ('.ais-facet-collections-container') {
        document.querySelector('.ais-facet-collections-container').style.minHeight = 'auto';
      }
      if ((payload[0].intersectionRatio > 0 && !showMoreButton.hasAttribute('disabled'))) {
        // $("body").off('click');
        const handler = (e) => {
          document.body.removeEventListener('click', handler);
        };
        document.body.addEventListener('click', handler);
        
        showMoreButton.click();
      } else if (payload[0].intersectionRatio > 0 && showMoreButton.hasAttribute('disabled')) {
 
        const featuredProducts = document.getElementById('featured-products');
        if (featuredProducts !== null) {
          featuredProducts.removeAttribute('style');
          if (featuredProducts.querySelectorAll('.slider__slide').length > 2) {
            featuredProducts.querySelector('.featured-section .slider-buttons').removeAttribute('style');
          }
        }
      }
    }

    function getNextPage() {
      ob.observe(showMoreButton);

      if (firstTry == false) {
        window.tryQty++;
        if (window.icallofzColl > 0) {
          window.icallofzColl = 1;
          window.zooomyColl(jQuery);
        }
      } else {
        if (window.icallofzColl > 0) {
          window.icallofzColl = 1;
          window.zooomyColl(jQuery);
        }
        firstTry = false;
      }
      
      if (window.collectionMore.length <= 4 && document.querySelector('.ais-facet-collections .ais-Menu-showMore')) {
        document.querySelector('.ais-facet-collections .ais-Menu-showMore').style.display = 'none';
      } else {
        document.querySelector('.ais-facet-collections .ais-Menu-showMore').removeAttribute('style');
      }
    }

    getNextPage();

    (function () {
      let pushState = history.pushState,
        replaceState = history.replaceState;

      history.pushState = function () {
        pushState.apply(history, arguments);
        window.dispatchEvent(new Event('pushstate'));
        window.dispatchEvent(new Event('locationchange'));
      };

      history.replaceState = function () {
        replaceState.apply(history, arguments);
        window.dispatchEvent(new Event('replacestate'));
        window.dispatchEvent(new Event('locationchange'));
      };

      window.addEventListener('popstate', function () {
        window.dispatchEvent(new Event('locationchange'))
      });
    })();

    window.addEventListener('locationchange', function () {
      getNextPage();
    });

    const showAllLinks = document.querySelectorAll('.ais-RefinementList-showMore, .ais-Menu-showMore'),
      select = document.querySelector('.ais-SortBy-select'),
      stats = document.querySelector('.query-term'),
      hiddenMenu = document.querySelectorAll('.ais-Menu-item[hidden="true"]');

    if (showAllLinks.length > 0) {
      showAllLinks.forEach(function (link) {
        link.addEventListener('click', function (event) {
          event.preventDefault();
          event.target.classList.toggle('is-active');

          if (event.target.classList.contains("ais-MenuList-showMore")) {
            hiddenMenu.forEach(function (item) {
              item.toggleAttribute('hidden');
            });
          }
        })
      });
    }
    if (select) {
      select.setAttribute("data-custom-select", "true");
      select.classList.add('c-custom-select');
      initCustomSelect();
    }
    if (queryTerm != undefined && queryTerm !== '' && document.querySelector('.ais-search-header .query-term')) {
      document.querySelector('.ais-search-header .query-term').innerHTML = queryTerm;
    }
    if (queryTerm != undefined && document.querySelector('.ais-stats--nb-results') && (document.querySelector('title').innerHTML).includes('Search:')) {
      let currentQty = (document.querySelector('.ais-stats--nb-results').innerHTML).replace(/[^0-9]/g,"");
      if (Number(currentQty) == 1) {
        document.querySelector('title').innerHTML = 'Search: ' + currentQty + ' result found for "' + queryTerm + '" – Plants Express';
      } else {
        document.querySelector('title').innerHTML = 'Search: ' + currentQty + ' results found for "' + queryTerm + '" – Plants Express';
      }
    }
  }
});
